<template>
    <div>
        <portal to="page-header">
            {{ $t('Withdrawal of') }} {{ withdrawal.amount | currency }} {{ $t('for') }} {{ withdrawal.player.username }}
        </portal>

        <portal to="actions">
            <div class="flex flex-row-reverse">
                <back-button
                    :route-name="'players.show'"
                    :route-param="withdrawal.player.id"
                >{{ $t('Details') }}</back-button>
                <back-button
                    :route-name="'withdrawals.index'"
                >{{ $t('Withdrawals') }}</back-button>
            </div>
        </portal>

        <form @submit.prevent="submit">
            <div class="flex flex-wrap">
                <div class="sm:px-1 md:px-3 lg:px-3 xl:px-3 w-full">
                    <card>
                        <div class="flex w-full">
                            <div class="px-4 py-2 w-1/2 sm:w-1/4">
                                <h4 class="font-normal text-gray-500 mt-2">{{ $t('Username') }}</h4>
                            </div>
                            <div class="py-2 px-4 w-1/2 sm:w-3/4">
                                <p class="">{{ withdrawal.player.username }}</p>
                            </div>
                        </div>
                        <div class="flex w-full">
                            <div class="px-4 py-2 w-1/2 sm:w-1/4">
                                <h4 class="font-normal text-gray-500 mt-2">{{ $t('Balance') }}</h4>
                            </div>
                            <div class="py-2 px-4 w-1/2 sm:w-3/4">
                                <p class="">{{ showFormattedAmount(balance, withdrawal.player.main_wallet.currency.code) }}</p>
                            </div>
                        </div>
                        <div class="flex w-full">
                            <div class="px-4 py-2 w-1/2 sm:w-1/4">
                                <h4 class="font-normal text-gray-500 mt-2">{{ $t('Amount') }}</h4>
                            </div>
                            <div class="py-2 px-4 w-1/2 sm:w-3/4">
                                <p class="">{{ showFormattedAmount(withdrawal.amount, withdrawal.currency.code) }}</p>
                            </div>
                        </div>
                        <div class="flex field-wrapper w-full">
                            <div class="px-4 py-2 w-1/2 sm:w-1/4">
                                <label for="pin" class="inline-block text-gray-500 pt-2 leading-tight">
                                    {{ $t('PIN') }}
                                </label>
                            </div>
                            <div class="py-2 px-4 w-1/2 sm:w-3/4">
                                <JetInput
                                    id="pin"
                                    ref="pin"
                                    type="number"
                                    min="1"
                                    v-mask="'####'"
                                    :placeholder="$t('PIN')"
                                    v-model="form.pin"
                                    class="w-full form-control form-input"
                                    autofocus
                                />
                                <JetInputError :message="errors.pin" class="mt-2" />
                            </div>
                        </div>
                    </card>
                </div>
            </div>

            <div class="sm:px-1 md:px-3 lg:px-3 xl:px-3 mt-4 flex justify-between items-center">
                <div class="max-w-md mr-4"></div>
                <btn :processing="form.processing" :type="'submit'">
                    {{ $t('Withdraw') }}
                </btn>
            </div>
        </form>
    </div>
</template>

<script>
import JetInput from '@/Jetstream/Input';
import JetInputError from '@/Jetstream/InputError';

import PageHeader from '../../Components/PageHeader';
import Card from '../../Components/Card';
import BackButton from '../../Components/BackButton';
import Btn from '../../Components/Btn';

export default {
    name: "Show",
    components: {Btn, PageHeader, Card, BackButton, JetInput, JetInputError},
    props: {
        withdrawal: Object,
        balance: Number,
        errors: Object
    },
    metaInfo() {
        return {
            title: this.title
        }
    },
    computed: {
        title () {
            return this.$t('Withdrawal');
        },
        confirm () {
            return this.$t('Are you sure you want to withdraw - ');
        }
    },
    data() {
        return {
            form: {
                pin: '',
                processing: false
            },
        }
    },
    mounted() {
        this.$refs.pin.focus();
    },
    methods: {
        async submit() {
            this.processing = true;
            await this.$inertia.put(route('withdrawals.process', this.withdrawal.id).url(), this.form, {
                onBefore: () => confirm(this.confirm + `${this.$formatCurrency(this.withdrawal.amount, this.withdrawal.currency.code)}?`)
            });
            this.processing = false;
        },
        showFormattedAmount(amount, currencyCode) {
            return this.$formatCurrency(amount, currencyCode);
        }
    },
}
</script>

<style scoped>

</style>
